import React from "react";
import Multiselect from "multiselect-react-dropdown";
import { useState } from "react";

import { convertArrayToCSV } from "convert-array-to-csv";
import FileSaver from "file-saver";
import "../../Dashboard/Dashboard.css";
import { toast } from "react-toastify";
import { TRANSACTION_HISTORY } from "../../../redux/Transactionhistory/types";
import { useEffect } from "react";
import { useDispatch } from "react-redux/es/exports";
import { useSelector } from "react-redux/es/exports";
import { AskpageNumber } from "../../Model/AskpageNumber";
import Pagination from "../../../utils/Pagination";
import axiosinstances from "../../../Helper/useAxios";

import { useNavigate } from "react-router-dom";
import { isUserAdmin } from "../../../utils/comman/Common";

const DmtSuuplierConfigList = () => {
  const [axiosInstance] = axiosinstances();
  const navigate = useNavigate();
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  
  const [showModal, setShowModel] = useState(false);
  const [selectedPage, setSelectedPage] = useState(1);
  const [search, setsearch] = useState("");
  const [paginationDetails, setPaginationDetails] = useState({
    currentPage: 1,
    postsPerPage: 20,
    totalPost: 0,
    totalPages: 0,
  });

  const [table, settable] = useState([]);
  const dispatch = useDispatch();
  //console.log('table', table)
  const token=JSON.parse(sessionStorage.getItem('token'))
  const  getDmtroutingresponse = () => {
		return  axiosInstance
		.get(`/api/v1/dmt/supplier-config/admin/get`,{ headers: {"Authorization" : `Bearer ${token}`,"client-id":id,"role":"ROLE_RETAILER_FINXPAY"}})
		.then(response => {
        
			if (response.status == 200) {
				//console.log('res routing', response)
                
				const { data } = response
				//setProfileDetails(data)
        settable(data);   
			} else if(response.status == 500) {  
            }
          
			return false
		})
	   .catch((err) => {
		 //console.log(err);
	   });
		
	}
  const fetchListOfRetailer = async (pageNo) => {
    const response = await axiosInstance
      .get(`/api/v1/dmt/supplier-config/admin/get`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        //console.log("res....>", res);
        if(res.status === 200){
            settable(res.data);
            // setPaginationDetails((prev) => {
            //   return {
            //     ...prev,
            //     totalPost: res.data?.totalElements,
            //     totalPages: res.data?.totalPages,
            //   };
            // });
        }
       
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  useEffect(() => {
    if(id !== undefined){
      getDmtroutingresponse();
    }
  }, [id]);

  const handalpageclick = async (index) => {
    fetchListOfRetailer(index - 1);
  };
  const totalpage = paginationDetails.totalPages;

  
  

  const searchdata = async () => {
    setsearch((search) => {
      return search;
    });
    const callingsearchapi = await searchapidata(search);

    setsearch("");

    //settable(() => callingsearchapi.orders);
  };

  const searchapidata = async (search) => {
    const trimSearch = search.trim()
    const response = await axiosInstance
      .get(`/api/v1/billpay/order/search/${trimSearch}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };
  const fetchpagedataInloop = async (pageNo) => {
    const response = await axiosInstance
      .get(`/api/v1/retailer/list/${pageNo}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "client-id": id,
          role: "ROLE_RETAILER_FINXPAY",
        },
      })
      .then((res) => {
        //console.log("res....>", res);
        return res;
      })
      .catch((err) => {
        //console.log(err);
        toast.error("Something went wrong");
      });
    if (response) {
      const result = response.data.orders;

      if (result) {
      }

      return response.data;
    }
    return false;
  };

  const enterTxnsearch = (event) => {
    event.preventDefault();

    setsearch(event.target.value);
  };

  const closePopUp = () => {
    setShowModel(false);
    setSelectedPage(1);
  };

  async function exportAllFile() {
    let result = [];
    for (let i = 0; i < selectedPage; i++) {
      const data = await fetchpagedataInloop(i);
      if (Array.isArray(data?.retailers)) {
        const unwantedHeaderForExcel = data.retailers.map((val) => {
          delete val.optional;
          delete val.transaction;
          //console.log("val11", val);
          const newvalues = val;
          //console.log("newvalues", newvalues);
          return newvalues;
        });
        //console.log("unwantedHeaderForExcel", unwantedHeaderForExcel);
        result.push(...unwantedHeaderForExcel);
      }
    }
    //console.log("result", result);
    const csv = convertArrayToCSV(result);
    const csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    FileSaver.saveAs(csvData, "data.csv");
    closePopUp();
    setSelectedPage(1);
  }
  const configureSuuplier = () => {
    navigate("/dmt-supplier-config");
  };
  const clearSearch = () => {
    setsearch("");
    dispatch({ type: TRANSACTION_HISTORY, id });
  };
  const profileDetails = (id) => {
    navigate(`/profile/${id}`);
  };
 const dmtconfigDetails = (details) =>{
  navigate('/dmt-supplier-config-details',{state:{...details}})
 }
  return (
    <React.Fragment>
      <AskpageNumber
        showModal={showModal}
        closePopUp={closePopUp}
        totalpage={totalpage}
        setSelectedPage={setSelectedPage}
        selectedPage={selectedPage}
        exportAllFile={exportAllFile}
      />
      <div class="mid">
        <div class="container-fluid">
          <div class="maincard">
            <div class="tab-content" id="mobiletab">
              <div
                class="tab-pane fade show active"
                id="nav-mobi"
                role="tabpanel"
                aria-labelledby="mobile-tab"
              >
                <div class="head">
                  <h3>Dmt Supplier Config List</h3>
                  <button class="btn" type="button" onClick={configureSuuplier}>
                  Configure Dmt Supplier 
                  </button>
                  {/* <div class="headsearch">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        onChange={(event) => enterTxnsearch(event)}
                        placeholder="Search transaction..."
                        value={search}
                      />
                      <button
                        class="btn search"
                        disabled={search.length <= 3}
                        type="button"
                        id="txnsrch"
                        onClick={searchdata}
                      >
                        search
                      </button>
                      <button
                        style={{ background: "#FF8D33", marginLeft: "3px" }}
                        class="btn delete"
                        // disabled={search.length <= 3}
                        type="button"
                        onClick={clearSearch}
                      >
                        clear
                      </button>
                    </div>
                  </div> */}
                </div>

                <div class="txn-list" id="recntxn">
                  {table !== undefined &&
                    table?.map((data) => {
                      const objLength =    data?.operatorMapping !== undefined && data?.operatorMapping !== null && Object.keys(data?.operatorMapping).length
                      return (
                        <div
                         onClick={()=>dmtconfigDetails(data)}
                          class="txn-item"
                          key={data.id}
                        >
                          <div class="txn-head" id="txnhead1">
                            <div
                              class="collapsed"
                              data-bs-toggle="collapse"
                              data-bs-target="#txn1"
                              aria-expanded="false"
                              aria-controls="txn1"
                            >
                              <div
                                class={`txncard success grbg`}
                              >
                                <div class="row">
                                  <div class="col-12 col-md-4">
                                    <div class="txntxt">
                                      {/* <li className="bill"> */}
                                      {/* <img src={require('../../assests/images/airtel.png')} alt="logo"/> */}
                                      <h6>
                                        ID: {data?.id !== undefined && data.id !== null  && data?.id} 
                                      </h6>
                                      {/* </li> */}
                                    </div>
                                    <div class="txntxt">
                                      <h6>
                                        Name: {data?.name !== undefined && data?.name !== null && data?.name}
                                      </h6>
                                    </div>
                                  </div>
                                  {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Txn ID: {data.requestId}</h6>
                                  </div>
                                </div> */}

                                  <div class="col-12 col-md-4">
                                    <div class="txntxt">
                                      <h6>URL: {data?.url !== undefined && data?.url !== null &&  data?.url}</h6>
                                      <h6>
                                      Payout Url: {data?.payoutUrl !== undefined && data?.payoutUrl !== null && data?.payoutUrl }
                                      </h6>
                                    </div>
                                  </div>
                                  <div class="col-12 col-md-4">
                                    <div class="txntxt">
                                      {/* <h4>
                                      ₹ {200}{" "}</h4> */}
                                      <h6>
                                        {" "}
                                        Operators :{ data?.operatorMapping !== undefined && data?.operatorMapping !== null && Object.keys(data?.operatorMapping).map((data,index)=>{
                                          return `${data}${objLength !== index + 1 ? ", " : ''}`
                                        }) }
                                        
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}

                  {/* <div class="pager">
                    {table !== undefined &&
                      table !== null &&
                      table.length > 0 &&
                      search == "" && (
                        <p>
                          Showing 1 to{" "}
                          {table.length < 10 ? table.length : table.length} of{" "}
                          {table !== undefined &&
                            table !== null &&
                            paginationDetails.totalPost}{" "}
                          entries{" "}
                          <button
                            class="lbbtn"
                            type="button"
                            onClick={onExportData}
                          >
                            Export
                          </button>
                        </p>
                      )}

                    {
                      paginationDetails.totalPost !== undefined &&
                        paginationDetails.totalPost !== null &&
                        paginationDetails.totalPost > 10 &&
                        search == "" && (
                          <Pagination
                            className="pagination-bar"
                            currentPage={paginationDetails.currentPage}
                            totalCount={paginationDetails.totalPost}
                            pageSize={paginationDetails.postsPerPage}
                            onPageChange={(page) => handalpageclick(page)}
                          />
                        )
                      // <Pagination  postsPerPage={paginationDetails.postsPerPage} totalPosts={table.length} paginate={paginate} currentPage={paginationDetails.currentPage} />
                    }
                  </div> */}
                </div>
              </div>

              <div
                class="tab-pane fade"
                id="mobi-grap"
                role="tabpanel"
                aria-labelledby="mobi-grap-tab"
              >
                {/* <TransactionGraph/>  */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DmtSuuplierConfigList;
